import { BASEURL, IMGBASEURL } from "@/config/index";

export default {
    imageBaseURL: BASEURL,
    imageS3BaseURL: !!IMGBASEURL ? IMGBASEURL : "https://img-dev.brij.tech/",

    movieImages: {
        moviesUploadThumbnailImage: "280*350",
    },
    dateFormat: "dd MMM yyyy",
    cookiekeys: {
        BRHSID: 'BRHSID'
    }
}



// WEBPACK FOOTER //
// ./src/helper/constant.js